import { render } from "./GoodsBolt.vue?vue&type=template&id=5a9af3e3&scoped=true"
import script from "./GoodsBolt.vue?vue&type=script&lang=js"
export * from "./GoodsBolt.vue?vue&type=script&lang=js"

import "./GoodsBolt.vue?vue&type=style&index=0&id=5a9af3e3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9af3e3"]])

export default __exports__